module.exports = __webpack_public_path__ + "img/logo.34f1f5b2.svg";